import { CmsObjectWithDefault } from '@components/Cms/types';

export type ResetPinResultCmsKey =
    | 'SuccessTitle'
    | 'SuccessCaption'
    | 'InvalidDob'
    | 'SessionExpired'
    | 'InvalidOtp'
    | 'TechnicalDifficulty'
    | 'CreatePinTitle'
    | 'CreatePinDisclaimer'
    | 'CreatePinCaption'
    | 'VerifyPinTitle'
    | 'VerifyPinCaption'
    | 'RequestBlockedReason'
    | 'RequestBlockedDetail';

export const ResetPinResultCmsWithDefault: CmsObjectWithDefault<ResetPinResultCmsKey> = {
    SuccessTitle: {
        cmsId: 368055,
        defaultTranslation: 'New PIN code has been set',
    },
    SuccessCaption: {
        cmsId: 368056,
        defaultTranslation: 'You can use it to access the wallet and authorise any future transactions',
    },
    InvalidDob: {
        cmsId: 368058,
        defaultTranslation: 'Error, authentication failed. Please wait a while and try again.',
    },
    SessionExpired: {
        cmsId: 368059,
        defaultTranslation: 'The Session has expired. Please try again.',
    },
    InvalidOtp: {
        cmsId: 398433,
        defaultTranslation: 'Invalid OTP input. Please try again',
    },
    TechnicalDifficulty: {
        cmsId: 101793,
        defaultTranslation: 'We are currently experiencing technical difficulties.',
    },
    CreatePinTitle: {
        cmsId: 358282,
        defaultTranslation: 'Create your 6-digit PIN',
    },
    CreatePinCaption: {
        cmsId: 421336,
        defaultTranslation:
            'For security, please avoid weak PIN codes with repeated or sequential numbers, such as 11111 or 123456.',
    },
    CreatePinDisclaimer: {
        cmsId: 358284,
        defaultTranslation: 'Do not share this code with anyone.',
    },
    VerifyPinCaption: {
        cmsId: 358287,
        defaultTranslation: 'Enter the same 6-digit PIN again to confirm',
    },
    VerifyPinTitle: {
        cmsId: 358286,
        defaultTranslation: 'Verify PIN code',
    },
    RequestBlockedReason: {
        cmsId: 416774,
        defaultTranslation: 'This account has been temporarily locked for security reasons.',
    },
    RequestBlockedDetail: {
        cmsId: 416776,
        defaultTranslation: 'Please wait until {0} to try again.',
    },
};
